// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__W2GHu","sm":"mimic___styles_sm__Uj8bN","md":"mimic___styles_md__Go6Rs","lg":"mimic___styles_lg__iI0cg"};